<div class="d-flex justify-content-end align-items-center" (clickOutside)="closeEmojiBar()">

  <div class="d-flex align-items-center me-1" *ngIf="totalReactions > 0">
    <p class="counter mb-0 me-1">{{ totalReactions }}</p>

    <ng-container *ngFor="let reaction of firstTwoReactions">
      <img [src]="reaction.img" class="emoji" [alt]="reaction.alt" />
    </ng-container>
  </div>

  <div
    class="reaction-wrapper"
    (mouseenter)="showEmojiBar = true"
    (mouseleave)="closeEmojiBar()"
  >


  <div *ngIf="showEmojiBar" class="emoji-bar">
    <img
      src="./../../../../../assets/icons/reactions/like_azul.png"
      class="emoji"
      alt="Like"
      [class.active]="userReaction === 'like'"
      [class.disabled]="userReaction !== null && userReaction !== 'like'"
      (click)="saveReaction('like')"
    />
    <img
      src="./../../../../../assets/icons/reactions/corazon_rojo.png"
      class="emoji"
      alt="Love"
      [class.active]="userReaction === 'love'"
      [class.disabled]="userReaction !== null && userReaction !== 'love'"
      (click)="saveReaction('love')"
    />
    <img
      src="./../../../../../assets/icons/reactions/emoji_risa.png"
      class="emoji"
      alt="Haha"
      [class.active]="userReaction === 'haha'"
      [class.disabled]="userReaction !== null && userReaction !== 'haha'"
      (click)="saveReaction('haha')"
    />
    <img
      src="./../../../../../assets/icons/reactions/emoji_sorpresa.png"
      class="emoji"
      alt="Wow"
      [class.active]="userReaction === 'wow'"
      [class.disabled]="userReaction !== null && userReaction !== 'wow'"
      (click)="saveReaction('wow')"
    />
    <img
      src="./../../../../../assets/icons/reactions/emoji_triste.png"
      class="emoji"
      alt="Sad"
      [class.active]="userReaction === 'sad'"
      [class.disabled]="userReaction !== null && userReaction !== 'sad'"
      (click)="saveReaction('sad')"
    />
  </div>



    <div
      class="reaction-box d-flex justify-content-center align-items-center"
    >
      <p class="mb-0 me-2">Reacciona</p>
      <img  [src]="getReactionImage()" alt="Like" class="emoji">
    </div>
  </div>

</div>
